<script lang="ts">
 /**
 * QR/barcode scanning bracket overlay on the viewfinder.
 *
 * @remarks
 * Rendered inside {@link CaptureViewfinder}'s default slot. Uses
 * `pointer-events-none` so it doesn't intercept taps on the controls
 * underneath (this was a z-index bug that was fixed early in Phase 1).
 *
 * Shows four corner brackets forming a scanning target area and a
 * status pill ("Scanning for QR codes...") when active.
 *
 * Phase 2 will integrate the BarcodeDetector API for real scanning.
 */
</script>

<script setup lang="ts">
defineProps<{
  /** Whether the scanner overlay is currently visible. */
  active: boolean
  /** Status message shown in the pill. Defaults to "Scanning for QR codes..." */
  status: string | null
}>()
</script>

<template>
  <!-- Overlay: absolute positioning is intentional — this component is rendered
       inside CaptureViewfinder's slot and must fill the parent viewfinder. -->
  <div
    v-if="active"
    class="pointer-events-none absolute inset-0 z-30 flex flex-col items-center justify-center"
  >
    <!-- Scanner brackets -->
    <div class="relative h-48 w-48">
      <div
        class="border-inverted/70 absolute top-0 left-0 h-8 w-8 rounded-tl-lg border-t-2 border-l-2"
      />
      <div
        class="border-inverted/70 absolute top-0 right-0 h-8 w-8 rounded-tr-lg border-t-2 border-r-2"
      />
      <div
        class="border-inverted/70 absolute bottom-0 left-0 h-8 w-8 rounded-bl-lg border-b-2 border-l-2"
      />
      <div
        class="border-inverted/70 absolute right-0 bottom-0 h-8 w-8 rounded-br-lg border-r-2 border-b-2"
      />
    </div>
    <div class="bg-inverted/60 text-inverted/70 mt-4 rounded-full px-4 py-1 text-xs">
      {{ status ?? "Scanning for QR codes..." }}
    </div>
  </div>
</template>
